import React from 'react';
import axios from 'axios';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import { MenuItem, Dropdown } from 'react-bootstrap';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import './style.css';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';
import yesIcon from '../host/assets/yes-icon.png';
import noIcon from '../host/assets/no-icon.png';
const moment = require('moment');

const cpdCompliantReport_Url = AdminUrls.ADMIN.CPDCOMPLAIANCEREPORT;
const cpdDownloadExcel = AdminUrls.ADMIN.COMPLIANTEXCEL;

class CompliantReport extends React.Component {
  constructor() {
    super();

    this.handlePageChange = this.handlePageChange.bind(this);

    this.clearSearchFilters = this.clearSearchFilters.bind(this);

    this.downloadExcel = this.downloadExcel.bind(this);

    this.getCpdCompliantReport = this.getCpdCompliantReport.bind(this);
    this.searchData = this.searchData.bind(this);
    this.pageChange = this.pageChange.bind(this);

    this.state = {
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdId: '',
      cpdBool: '',
      cpdMemberNum: '',
      cpdEmail: '',
      cpdUsername: '',
      cpdYear: '',
      loadCpdCompliant: [],
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      sort: {
        column: 'CompletionDate',
        direction: 'desc',
      },
    };
    this.controller = new AbortController();
  }

  downloadExcel(year) {
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(cpdDownloadExcel, {
      params: {
        reportId: this.state.cpdId,
        Year: year,
      },
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'CompliantReport.xlsx');
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
    });
    this.getCpdCompliantReport(pageNumber);
  }

  pageChange(pageQty) {
    this.setState(
      {
        per_page: pageQty,
      },
      () => {
        this.getCpdCompliantReport(this.state.activePage, this?.state?.cpdBool);
      }
    );
  }

  componentDidMount() {
    let id = this.props.match.params.reportid;

    if (id === 'CPD0002') {
      this.getCpdCompliantReport(1, true);
      this.setState({
        cpdBool: true,
        cpdId: this.props.match.params.reportid,
      });
    }
    if (id === 'CPD0003') {
      this.getCpdCompliantReport(1, false);
      this.setState({
        cpdBool: false,
        cpdId: this.props.match.params.reportid,
      });
    }
  }

  clearSearchFilters() {
    this.setState({
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 0,
      unauthorized: false,
      cpdEmail: '',
      cpdMemberNum: '',
      cpdUsername: '',
      cpdYear: '',
    });
    setTimeout(() => {
      this.getCpdCompliantReport(1, this.state.cpdBool);
    }, 1000);
  }

  getCpdCompliantReport(active, cpdBool, column, direction) {
    this.setState({
      mainLoading: true,
    });
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    this.setState({
      mainLoading: true,
    });
    if (column) {
      sortBy = column;
    }

    if (direction) {
      reverse = direction;
    }
    reverse = reverse === 'asc' ? false : true;
    axios
      .get(cpdCompliantReport_Url, {
        params: {
          IsCPDCompliant: cpdBool,
          page: active,
          pageSize: this.state.per_page,
          reverse: reverse,
          sortBy: sortBy,
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdCompliant: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  searchData() {
    let userNames = this.state.cpdUsername;
    let email = this.state.cpdEmail;
    let year = this.state.cpdYear;
    let pages = this.state.activePage;
    let memberNumbers = this.state.cpdMemberNum;

    this.setState({
      mainLoading: true,
    });

    let obj = {
      IsCPDCompliant: this.state.cpdBool,
      page: pages,
      pageSize: this.state.per_page,
    };

    if (userNames) {
      obj.UserName = userNames;
    }

    if (email) {
      obj.Email = email;
    }
    if (year) {
      obj.Year = year;
    }
    if (memberNumbers) {
      obj.MemberNumber = memberNumbers;
    }

    axios
      .get(cpdCompliantReport_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          loadCpdCompliant: response?.data?.Items,
          activePage: response?.data?.Page,
          totalCount: response?.data?.TotalCount,
          totalPages: response?.data?.TotalPages,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState({
      sort: {
        column,
        direction,
      },
    });
    this.getCpdCompliantReport(
      this.state.activePage,
      this.state.cpdBool,
      column,
      direction
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let loadCpdCompliant;

    if (this.state?.loadCpdCompliant !== null) {
      loadCpdCompliant = this.state?.loadCpdCompliant?.map((item, index) => {
        return (
          <tr key={index}>
            <td>{item?.MemberNumber}</td>
            <td>{item?.username}</td>
            <td>{item?.Email}</td>
            <td>
              {item?.IsCPDCompliant === true ? (
                <img src={yesIcon} alt="yesIcon" />
              ) : (
                <img src={noIcon} alt="noIcon" />
              )}
            </td>
            <td>{item?.CPDYear}</td>
            <td>{item?.Duration}</td>
            <td>{item?.RemainingDuration}</td>
            <td>
              {item?.DeclaredDate
                ? moment(item?.DeclaredDate).format('ll')
                : 'na'}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>UserName</label>
                        <input
                          type="user name"
                          value={this.state.cpdUsername}
                          className="form-control"
                          id="user name"
                          onChange={(e) =>
                            this.setState({ cpdUsername: e.target.value })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Email</label>
                        <input
                          type="email"
                          className="form-control"
                          value={this.state.cpdEmail}
                          onChange={(e) =>
                            this.setState({ cpdEmail: e.target.value })
                          }
                          id="email"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Memebership number</label>

                        <input
                          type="memebership number"
                          className="form-control"
                          id="memebership number"
                          value={this.state.cpdMemberNum}
                          onChange={(e) =>
                            this.setState({ cpdMemberNum: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Year</label>
                        <select
                          value={this.state.cpdYear}
                          className="form-control"
                          onChange={(e) =>
                            this.setState({
                              cpdYear: e.target.value,
                            })
                          }
                          id="sel1"
                        >
                          <option></option>
                          <option value={'2023'}>2023</option>
                          <option value={'2024'}>2024</option>
                          <option value={'2025'}>2025</option>
                          <option value={'2026'}>2026</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchData}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="gridTopButtons">
              <button
                type="button"
                onClick={() => window.print()}
                className="btn btn-danger btn-circle btn-lg "
              >
                <i className="fa fa-print"> </i>
              </button>

              <Dropdown id="dropdown-custom-1">
                <Dropdown.Toggle
                  className="btn btn-success btn-circle btn-lg"
                  style={{ marginLeft: '10px' }}
                  noCaret
                >
                  <i className="fa fa-file-pdf-o"> </i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel('All');
                    }}
                    eventKey="4"
                  >
                    All
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2023);
                    }}
                    eventKey="4"
                  >
                    2023
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2024);
                    }}
                    eventKey="5"
                  >
                    2024
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2025);
                    }}
                    eventKey="6"
                  >
                    2025
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.downloadExcel(2026);
                    }}
                    eventKey="7"
                  >
                    2026
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="col-md-6">
            <div className="gridTopDropdown">
              Show{' '}
              <select
                className="input-sm"
                aria-invalid="false"
                onChange={(e) => this.pageChange(e.target.value)}
              >
                <option label="10" value="10">
                  10
                </option>
                <option label="20" value="20">
                  20
                </option>
                <option label="30" value="30">
                  30
                </option>
              </select>{' '}
              entries
            </div>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th onClick={this.onSort('MemberNumber')}>
                  Member Number{' '}
                  <i className={this.setArrow('MemberNumber')}> </i>
                </th>
                <th onClick={this.onSort('username')}>
                  User Name <i className={this.setArrow('username')}> </i>
                </th>
                <th onClick={this.onSort('Email')}>
                  Email <i className={this.setArrow('Email')}> </i>
                </th>
                <th>CPD Compliant</th>
                <th onClick={this.onSort('CPDYear')}>
                  Year <i className={this.setArrow('CPDYear')}> </i>
                </th>
                <th onClick={this.onSort('Duration')}>
                  Completed Hours<i className={this.setArrow('Duration')}> </i>
                </th>
                <th onClick={this.onSort('RemainingDuration')}>
                  Remaining Hours{' '}
                  <i className={this.setArrow('RemainingDuration')}> </i>
                </th>
                <th onClick={this.onSort('DeclaredDate')}>
                  Declared Date{' '}
                  <i className={this.setArrow('DeclaredDate')}> </i>
                </th>
              </tr>
            </thead>
            <tbody>{loadCpdCompliant}</tbody>
          </table>
          {loadCpdCompliant?.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CompliantReport);
